<template>
  <el-card class="no-border">
    <!--just add it here to make the style work-->
    <div class="ql-snow">
      <div class="ql-editor">
        <vue-editor style="display:none"> </vue-editor>
        <div v-html="body"></div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: ["body"] //user id
};
</script>
